import React from "react";
import PdfContainer from "./PdfContainer";

const Communications = (props) => <PdfContainer {...props} />;

export default Communications;
